import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "annex-alarm-acknowledge-info" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnnexAlarmTimer = _resolveComponent("AnnexAlarmTimer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.debug)
      ? (_openBlock(), _createElementBlock("pre", _hoisted_2, "      Server time: " + _toDisplayString(_ctx.serverTime) + "\n      Item created at: " + _toDisplayString(_ctx.item.created_at) + "\n      Ack interval: " + _toDisplayString(_ctx.item.ack_interval) + "\n      Time from: " + _toDisplayString(_ctx.timeFrom) + "\n    ", 1))
      : _createCommentVNode("", true),
    (_ctx.adaptedItem.acknowledge === 'none')
      ? (_openBlock(), _createBlock(_component_AnnexAlarmTimer, {
          key: _ctx.timeFrom,
          from: _ctx.timeFrom,
          to: 0,
          step: -1,
          i18n_message: "annex_alarms.auto_acknowledge_mf",
          onFinished: _ctx.timerFinished
        }, null, 8, ["from", "onFinished"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createTextVNode(_toDisplayString(_ctx.acknowledgeMessage), 1)
        ], 64))
  ]))
}